import React from "react";
import { NavLink } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { Phone, Mail, MapPin } from "lucide-react";
import { FaInstagram, FaTelegram, FaYoutube } from "react-icons/fa";

const Footer = () => {
  const quickLinks = [
    { label: "About Us", path: "/about-upsc" },
    { label: "Our Courses", path: "/courses" },
    { label: "Our Team", path: "/#team" }, // now uses hash
    { label: "Contact", path: "/#contact" }, // now uses hash
  ];

  const contactInfo = [
    {
      icon: <Phone className="text-red-400 w-4 h-4" />,
      text: "+91 8012003040",
    },
    {
      icon: <Mail className="text-red-400 w-4 h-4" />,
      text: "selvasiasacademy@gmail.com",
    },
    {
      icon: <MapPin className="text-red-400 w-4 h-4" />,
      text: "Chennai, India",
    },
  ];

  const socialLinks = [
    {
      icon: <FaInstagram />,
      href: "https://www.instagram.com/selvas_ias_academy?igsh=dW83enprOGRtMWR3",
    },
    {
      icon: <FaYoutube />,
      href: "https://youtube.com/@selvasiasacademy?si=fz9ykMgZpap6mCn6",
    },
    { icon: <FaTelegram />, href: "https://t.me/Selvasanthro" },
  ];

  return (
    <footer className="bg-indigo-900 text-gray-200 pt-12 pb-6 px-6 md:px-16">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* IAS Academy Info */}
        <div>
          <h3 className="text-lg font-bold mb-3">Selva's IAS Academy</h3>
          <p className="text-sm leading-relaxed">
            Empowering aspirants with the right knowledge, strategies, and
            mentorship to achieve their UPSC dreams.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-bold mb-3">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            {quickLinks.map((link, idx) => (
              <li key={idx}>
                {link.path.includes("#") ? (
                  <HashLink
                    smooth
                    to={link.path}
                    className="hover:text-white transition"
                  >
                    {link.label}
                  </HashLink>
                ) : (
                  <NavLink
                    to={link.path}
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: "smooth" })
                    }
                    className={({ isActive }) =>
                      `hover:text-white transition ${
                        isActive ? "text-red-700 font-semibold" : ""
                      }`
                    }
                  >
                    {link.label}
                  </NavLink>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-lg font-bold mb-3">Contact Us</h3>
          <ul className="space-y-3 text-sm">
            {contactInfo.map((info, idx) => (
              <li key={idx} className="flex items-center gap-2">
                {info.icon} {info.text}
              </li>
            ))}
          </ul>
        </div>

        {/* Social Media */}
        <div>
          <h3 className="text-lg font-bold mb-3">Follow Us</h3>
          <div className="flex gap-4">
            {socialLinks.map((social, idx) => (
              <a
                key={idx}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-indigo-900 p-2 rounded-full hover:bg-red-600 hover:text-white transition"
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      
      <div className="mt-10 border-t border-gray-600 pt-4 text-center text-sm text-gray-300 flex flex-col gap-1">
        <span>© 2026 Selva’s IAS Academy. All Rights Reserved.</span>
        <span>
          Developed By{" "}
          <a
            href="https://crackdevelopers.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-red-400 font-semibold transition"
          >
            crackdevelopers
          </a>
        </span>
        </div>
      
    </footer>
  );
};

export default Footer;
